import { render, staticRenderFns } from "./MassivePoiImport.vue?vue&type=template&id=2e2b628e&"
import script from "./MassivePoiImport.vue?vue&type=script&lang=js&"
export * from "./MassivePoiImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports